import { lazy } from 'react';

const Earn24_7SectionLazy = lazy(() => import('../Earn24_7Section'));

export default Earn24_7SectionLazy;
